'use client';

import { useSyncExternalStore } from 'react';

/**
 * Returns false on the server and during the client's first paint
 * (matching the server snapshot). Returns true after React commits
 * hydration. Use to gate any data-driven render branch so the server
 * HTML matches the client's first render.
 *
 * @returns {boolean}
 */
const subscribe = () => () => {};
const getServerSnapshot = () => false;
const getClientSnapshot = () => true;

export default function useIsHydrated() {
  return useSyncExternalStore(subscribe, getClientSnapshot, getServerSnapshot);
}
